module.exports = __webpack_public_path__ + "static/2.6165387b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msc/2.png
// module id = 887
// module chunks = 144974278801183 275805287939862